import { useTranslation } from 'react-i18next'
import SubHeaders from '@/components/Headers/SubHeaders'
import { paths } from '@/utils/path'
import NavigationCards from './NavigationCards'
import PersonalInfo from './PersonalInfo'
import { useLocation } from 'react-router-dom'

const Detail = () => {
    const { t } = useTranslation()
    const location = useLocation()
    // const { data, refetch, renderState } = useQueryWithHandler({
    //     queryKey: [QUERY_KEYS.EMPLOYEE_CURRENT_INFO],
    //     queryFn: async () => await getCurrentEmployee(),
    // })

    // const stateComponent = renderState()
    // if (stateComponent) return stateComponent

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    { path: paths.account, title: t('account') },
                    { path: '', title: t('detailed-information') },
                ]}
            />

            <NavigationCards>
                {location.pathname === '/account/info' && (
                    <div>
                        <PersonalInfo />
                        {/* <ContactInfo employee={employee} refetch={refetch} /> */}
                    </div>
                )}
            </NavigationCards>
        </div>
    )
}

export default Detail
